import { GET_SHARE_TRIP_REQUESTED, GET_TRIP_REQUESTED } from "resources/actionTypes";

export function getTrip(data) {
  return {
    type: GET_TRIP_REQUESTED,
    payload:data
  };
}
export function shareTrip(data){
  return {
    type: GET_SHARE_TRIP_REQUESTED,
    payload:data
  }
}